export const Upcoming_events_list = [
  {
    index: 0,
    name: "Debate Competition",
    startDate: "20 January",
    endDate: "18 September",
  },
  {
    index: 1,
    name: "Story Writing Competition",
    startDate: "20 January",
    endDate: "18 September",
  },
  {
    index: 2,
    name: "Poetry Competition",
    startDate: "20 January",
    endDate: "18 September",
  },
  {
    index: 3,
    name: "Debate Competition",
    startDate: "20 January",
    endDate: "18 September",
  },
  {
    index: 4,
    name: "Debate Competition",
    startDate: "20 January",
    endDate: "18 September",
  },
  {
    index: 5,
    name: "Spill the ink 3.0 - Debate Competition",
    startDate: "20 January",
    endDate: "18 September",
  },
];
export const Previous_events_list = [
  {
    index: 0,
    name: "Spill the ink 2.0 - Debate Competition",
    startDate: "20 January",
    endDate: "18 September",
  },
  {
    index: 1,
    name: "Spill the ink 2.0 - Debate Competition",
    startDate: "20 January",
    endDate: "18 September",
  },
  {
    index: 2,
    name: "Spill the ink 2.0 - Debate Competition",
    startDate: "20 January",
    endDate: "18 September",
  },
  {
    index: 3,
    name: "Spill the ink 2.0 - Debate Competition",
    startDate: "20 January",
    endDate: "18 September",
  },
  {
    index: 4,
    name: "Spill the ink 2.0 - Debate Competition",
    startDate: "20 January",
    endDate: "18 September",
  },
  {
    index: 5,
    name: "Spill the ink 2.0 - Debate Competition",
    startDate: "20 January",
    endDate: "18 September",
  },
];
